module.exports = __webpack_public_path__ + "static/golf-3cbf97262e9351fb509807ec41fd8574.mp4";